import SIMPLE_WORKBOOK_BUNDLE_49 from './fake/SIMPLE_WORKBOOK_BUNDLE_49'
import SIMPLE_WORKBOOK_BUNDLE_90 from './fake/SIMPLE_WORKBOOK_BUNDLE_90'
import SIMPLE_WORKBOOK_BUNDLE_64 from './fake/SIMPLE_WORKBOOK_BUNDLE_64'

import SIMPLE_WORKBOOK_BUNDLE_36 from './SIMPLE_WORKBOOK_BUNDLE_36'
import SIMPLE_WORKBOOK_BUNDLE_48 from './SIMPLE_WORKBOOK_BUNDLE_48'
import SIMPLE_WORKBOOK_BUNDLE_19_99 from './SIMPLE_WORKBOOK_BUNDLE_19_99'
import SIMPLE_WORKBOOK_BUNDLE_29_99 from './SIMPLE_WORKBOOK_BUNDLE_29_99'
import SIMPLE_WORKBOOK_BUNDLE_35 from './SIMPLE_WORKBOOK_BUNDLE_35'
import SIMPLE_WORKBOOK_BUNDLE_26 from './SIMPLE_WORKBOOK_BUNDLE_26'

import SIMPLE_PREMIUM_COMM_1M_49_99_6M_20 from '../upgrade/SIMPLE_PREMIUM_COMM_1M_49_99_6M_20'
import SIMPLE_PREMIUM_COMM_1M_49_99_6M_16 from '../upgrade/SIMPLE_PREMIUM_COMM_1M_49_99_6M_16'

export default {
	SIMPLE_WORKBOOK_BUNDLE_49,
	SIMPLE_WORKBOOK_BUNDLE_90,
	SIMPLE_WORKBOOK_BUNDLE_64,

	SIMPLE_WORKBOOK_BUNDLE_36,
	SIMPLE_WORKBOOK_BUNDLE_48,
	SIMPLE_WORKBOOK_BUNDLE_19_99,
	SIMPLE_WORKBOOK_BUNDLE_29_99,
	SIMPLE_WORKBOOK_BUNDLE_35,
	SIMPLE_WORKBOOK_BUNDLE_26,

	SIMPLE_PREMIUM_COMM_1M_49_99_6M_20,
	SIMPLE_PREMIUM_COMM_1M_49_99_6M_16,
}
